import { createFileRoute } from '@tanstack/react-router';
import CompanyCreate from '../../../features/baseData/companies/company/create';
import {
  COMPANIES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/firmen/neu')({
  component: CompanyCreate,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COMPANIES_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateCompanyRoute = Route;
